import styled from 'styled-components';
import { em } from 'polished';
import { media } from 'core/layout';
import { colors } from 'core/theme';

export const StyledItem = styled.li`
    border-bottom: 1px solid ${colors.hairline};
    padding-bottom: 1em;

    a {
        color: inherit;
        display: block;
        text-decoration: none;

        &:hover > h2 {
          color: ${colors.primary};
        }

        &:visited > h2 {
          color: ${colors.visited};
        }
    }

    & + & {
        margin-top: 1em;
    }

    @media print {
      page-break-inside: avoid;
    }
`;

export const StyledHeading = styled.h2`
    font-size: ${em(18)};
    font-weight: 500;
    color: ${colors.text};
    margin-top: 0;
    margin-bottom: 0.5em;
`;

export const TagsList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    font-size: ${em(14)};
    color: ${colors.lightText};

    ${media.tabletSmall`
      flex-wrap: wrap;
    `};

    & > li + li {
        margin-left: 24px;

        ${media.tablet`
            margin-left: 16px;
        `};

        ${media.tabletSmall`
          margin-left: 0;
          margin-top: 0.25em;
        `};
    }

    & > li {
        flex: 0 0 ${(2/7) * 100}%;

        ${media.tabletSmall`
          flex: none;
          width: 100%;
        `};

        @media print {
          flex: 1;
          width: auto;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/RezultatsItem/styled.js